import { Routes } from '@angular/router';

export const DEV_ONLY_ROUTES: Routes = [	
	
];
